// extracted by css-extract-rspack-plugin
module.exports =  {"icon":"Report__icon--VXcUa","print":"Report__print--_rqeJ","newline":"Report__newline--U2Sy7"};